import { isNonEmptyString } from '../helpers/utilsHelper.js';
import repository from './repository.js';

export default {
  async getItemsObject(
    page,
    itemsPerPage,
    search,
    sortBy,
    orderType,
    url,
    initialUserFilter = null,
    userFilter = null,
    usePOSTWithParams = null,
    abortSignal = null,
    cleanPOSTParams = true,
    forcePOST = false
  ) {
    let userFilterUrlEnding = '';
    const searchFilter = isNonEmptyString(search) ? `&search=${search}` : '';

    if (initialUserFilter) {
      for (const property in initialUserFilter) {
        userFilterUrlEnding += `&${property}=${initialUserFilter[property]}`;
      }
    }

    if (userFilter) {
      for (const property in userFilter) {
        if (Array.isArray(userFilter[property])) {
          userFilter[property].forEach((x) => {
            userFilterUrlEnding += `&${property}[]=${x}`;
          });
        } else userFilterUrlEnding += `&${property}=${userFilter[property]}`;
      }
    }

    const requestConfig = {
      signal: abortSignal ?? undefined
    };

    if (forcePOST || usePOSTWithParams != null) {
      // Clean usePOSTWithParams object by removing null, undefined, and empty array fields
      const cleanedPOSTParams =
        usePOSTWithParams == null
          ? null
          : Object.entries(usePOSTWithParams).reduce((acc, [key, value]) => {
              if (value === null || value === undefined) return acc;
              if (Array.isArray(value) && value.length === 0) return acc;

              acc[key] = value;
              return acc;
            }, {});

      return repository
        .post(
          `/${url}?page=${page}${searchFilter}&orderBy=${sortBy}&orderType=${orderType}&paginate=${itemsPerPage}${userFilterUrlEnding}`,
          cleanPOSTParams ? cleanedPOSTParams : usePOSTWithParams,
          requestConfig
        )
        .then((response) => {
          if (response.data.error == null) return response.data;
        })
        .catch((error) => {
          return { error };
        });
    }

    return repository
      .get(
        `/${url}?page=${page}${searchFilter}&orderBy=${sortBy}&orderType=${orderType}&paginate=${itemsPerPage}${userFilterUrlEnding}`,
        requestConfig
      )
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((error) => {
        return { error };
      });
  },

  async simplePUT(url, item) {
    return repository
      .put(url, item)
      .then((response) => {
        return response?.data?.message ?? null;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async fetchPostAndQueryParams(url, queryParams, postData) {
    let queryString = '';

    if (queryParams) {
      for (const property in queryParams) {
        if (Array.isArray(queryParams[property])) {
          queryParams[property].forEach((x) => {
            queryString += `&${property}[]=${x}`;
          });
        } else {
          queryString += `&${property}=${queryParams[property]}`;
        }
      }
    }

    if (queryString.startsWith('&')) {
      queryString = '?' + queryString.substring(1);
    } else if (queryString.length > 0) {
      queryString = '?' + queryString;
    }

    return repository
      .post(`/${url}${queryString}`, postData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return { error };
      });
  },

  async fetchPostAndQueryParamsWithFormData(url, queryParams, formData) {
    let queryString = '';

    if (queryParams) {
      for (const property in queryParams) {
        if (Array.isArray(queryParams[property])) {
          queryParams[property].forEach((x) => {
            queryString += `&${property}[]=${x}`;
          });
        } else {
          queryString += `&${property}=${queryParams[property]}`;
        }
      }
    }

    if (queryString.startsWith('&')) {
      queryString = '?' + queryString.substring(1);
    } else if (queryString.length > 0) {
      queryString = '?' + queryString;
    }

    return repository
      .post(`/${url}${queryString}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return { error };
      });
  },

  async simpleGet(url, search = '', userFilter = null) {
    let userFilterUrlEnding = '';

    if (userFilter) {
      for (const property in userFilter) {
        if (Array.isArray(userFilter[property])) {
          userFilter[property].forEach((x) => {
            userFilterUrlEnding += `&${property}[]=${x}`;
          });
        } else userFilterUrlEnding += `&${property}=${userFilter[property]}`;
      }
    }

    return repository
      .get(`${url}?search=${search}${userFilterUrlEnding}`)
      .then((response) => {
        return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async simpleDelete(url) {
    return repository
      .delete(url)
      .then((response) => {
        return response?.data ?? null;
      })
      .catch((serverError) => {
        return { serverError };
      });
  }
};
